/**
 * Adzuki.TextareaAutoheight
 */

(function TextareaAutoheight($, Adzuki)
{
	"use strict";

	var autoheight = function autoheight($els)
	{
		// makes sure the required css is applied
		$els.addClass('autoheight');

		$els.on('input', function autosize() {
			var $self         = $(this);
			var defaultHeight = 50;
			var textHeight;

			// MEASURED FROM NOTHING, NOT FROM THE CURRENT HEIGHT.
			//
			// scrollHeight can never report less than clientHeight, so measuring the box this
			// textarea already has meant it could only ever GROW: type five lines and delete four,
			// and it kept the height the five lines had earned. Clearing first makes scrollHeight
			// describe the CONTENT rather than the box that content used to need.
			//
			// SET-125 MADE THE IDENTICAL CORRECTION to the other resizer in this codebase,
			// form.js's __textareaResize, and made it shared for the same reason: every
			// textarea.autoheight in the app has this behaviour today, growing is unchanged, and
			// only the shrink is new. The css floor (textarea.autoheight is min-height 38px) and
			// the 50px default below are what stop it collapsing past one row.
			$self.css('height', 'auto');

			textHeight = this.scrollHeight - $self.data('autoheight-diff');

			if (textHeight < defaultHeight) {
				textHeight = defaultHeight;
			}

			$self.height(textHeight);
		});

		// $els.on('input', Adzuki.Debounce(function autosize() {
		// 	var $self = $(this);
		// 	$self.height(0).height(this.scrollHeight - $self.data('autoheight-diff'));
		// }, 100));

		// only need to calculate this once per textarea
		$.each($els, function init() {
			var $self = $(this),
				diff  = parseInt($self.css('paddingBottom'))
						+ parseInt($self.css('paddingTop'))
						+ parseInt($self.css('borderTopWidth'))
						+ parseInt($self.css('borderBottomWidth')) || 0;

			$self.data('autoheight-diff', diff);

			// override max-height if desired
			if ($self.data('max-height')) {
				$self.css('max-height', $self.data('max-height')+'px');
			}

			// if pre-filled, resize immediately
			if ($self.val()) {
				$self.trigger('input');
			}
		});
	};

	Adzuki.TextareaAutoheight = autoheight;
}(jQuery, window.Adzuki || {}));
